<template>
  <font-awesome-icon
    icon="circle-notch"
    :size="getSize"
    class="animate-spin mx-auto text-primary dark:text-primary-100"
  />
</template>
<script>
export default {
  name: "LoadingSpinner",
  props: {
    size: {
      type: String,
      default: "lg",
      required: false,
    },
  },
  computed: {
    getSize() {
      const sizes = {
        sm: "1x",
        md: "2x",
        lg: "3x",
        xl: "5x"
      }
      return sizes[this.size]
    }
  }
};
</script>